import { useContext } from 'react'
import { UserPreferredStoreContext } from '~/providers/UserPreferredStoreProvider/UserPreferredStoreProvider'

export const useUserPreferredStore = () => {
  return useContext(UserPreferredStoreContext)
}
